import { useEffect, useMemo, useState } from 'react';
import { CustomFieldDefinition, CustomFieldValue } from '../../../types';
import { fetchCustomFieldDefinitionsApi } from './customFieldDefinitionsApi';

// The definitions a single record can be edited against: fetched for the record's own account, because that is the
// account the value upsert authorizes the write on, and narrowed to the slots the record's payload actually carried —
// a definition outside that set has a value the client was never sent, and offering it blank would overwrite it.
export const useRecordCustomFieldDefs = (
  accountId: string | null | undefined,
  customFields: CustomFieldValue[] | undefined,
  entityType?: string
): CustomFieldDefinition[] => {
  const [defs, setDefs] = useState<CustomFieldDefinition[]>([]);

  useEffect(() => {
    if (!accountId) {
      setDefs([]);
      return;
    }
    // The drawer reuses one instance across records, so without this the slower of two in-flight fetches wins.
    let current = true;
    fetchCustomFieldDefinitionsApi(accountId, undefined, entityType).then(({ data }) => {
      if (!current) return;
      setDefs((data ?? []).filter((def) => !def.is_archived).sort((a, b) => a.position - b.position));
    });
    return () => {
      current = false;
    };
  }, [accountId, entityType]);

  return useMemo(
    () => defs.filter((def) => (customFields ?? []).some((cf) => cf.definition_id === def.id)),
    [defs, customFields]
  );
};
